<template>
    <v-container fluid>
        <div v-if="loading===false">
            <v-row v-if="error===true">
                <v-col cols="12" class="d-flex flex-column align-center justify-center" style="min-height: 300px;">
                    <img src="@/assets/dashboard/oops.svg" alt="Error" style="max-width: 300px; margin-bottom: 24px;" />
                    <div class="text-h5 font-weight-bold mt-4 text-center" style="color: #424242;">
                        {{ error_message }}
                    </div>
                </v-col>
            </v-row>
            <v-row v-if="error===false">
                <v-row justify="center" class="pt-4" v-if="process_ok===false">
                    <v-col cols="12" sm="10" md="8" lg="6">
                        <v-card class="mx-auto" elevation="0">
                            <div class="text-h4 text-center mb-6 font-weight-bold">
                                <v-icon left large :color="titleIconColor">{{ buttonIcon }}</v-icon> {{ pageTitle }}
                            </div>                                                        
                            <v-card-text>
                                <v-card outlined>
                                    <v-card-subtitle >
                                        <div class="mx-auto">
                                            <div style="display: flex; flex-direction: row; align-items: center;">
                                            <v-icon left color="warning">mdi-alert</v-icon>
                                            <div v-if="answer === 'false'" class="font-weight-bold" style="font-size: 1.1rem;">You are about to <b>reject</b> the following home owner booking because of active restrictions:</div>
                                            <div v-else class="font-weight-bold" style="font-size: 1.1rem;">You are about to <b>approve</b> the following home owner booking despite of active restrictions:</div>
                                            </div>
                                            <div 
                                                style="display: grid; 
                                                    grid-template-columns: 1fr 11fr; 
                                                    column-gap: 10px; 
                                                    margin-top: 10px; border-top: 1px solid #ccc; 
                                                    border-bottom: 1px solid #ccc; 
                                                    padding: 10px 0;
                                                    margin-top: 20px;
                                                    margin-bottom: 10px;">
                                                <div class="label" style="font-weight: bold;">Owner</div>
                                                <div class="value">{{ currentHeho.gebr_nw_naam }} ({{ currentHeho.gebr_nw_code }})</div>
                                                <div class="label" style="font-weight: bold;">Remark</div>
                                                <div class="value">{{ currentHeho.opm_eign }}</div>
                                                <div class="label" style="font-weight: bold;">Restriction(s)</div>
                                                <div class="value" v-html="currentHeho.restrictionTextAres" />
                                            </div>
                                        </div>  
                                    </v-card-subtitle>                                    
                                    <v-simple-table dense style="margin-bottom: 20px; margin-left: 15px; margin-right: 15px;">
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <th class="text-left">Booking ID</th>
                                                    <th class="text-left">Code</th>
                                                    <th class="text-left">Property</th>
                                                    <th class="text-left">Arrival</th>
                                                    <th class="text-left">Departure</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>{{ currentHeho.boek_code }}</td>
                                                    <td>{{ currentHeho.hust_label }}</td>
                                                    <td>{{ currentHeho.huis_naam}} ({{ currentHeho.huis_code }})</td>
                                                    <td>{{ formatDate(currentHeho.van_datum) }}</td>
                                                    <td>{{ formatDate(currentHeho.tm_datum) }}</td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </v-card>                        
                                <v-card outlined v-if="answer === 'true'" style="margin-top: 20px;">
                                    <v-card-subtitle class="font-weight-bold" style="font-size: 1.1rem; background-color: #f5f5f5; border-bottom: 1px solid #ccc;">
                                        The following bookings were already approved in the past year despite of active restrictions:
                                    </v-card-subtitle>                                
                                    <v-simple-table dense>
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <th class="text-left">Booking ID</th>
                                                    <th class="text-left">Code</th>
                                                    <th class="text-left">Property</th>
                                                    <th class="text-left">Arrival</th>
                                                    <th class="text-left">Departure</th>
                                                    <th class="text-center">Remark</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="booking in hehoList" :key="booking.boek_code">
                                                    <td>{{ booking.boek_code }}</td>
                                                    <td>{{ booking.hust_label }}</td>
                                                    <td>{{ booking.huis_naam }} ({{ booking.huis_code }})</td>
                                                    <td>{{ formatDate(booking.van_datum) }}</td>
                                                    <td>{{ formatDate(booking.tm_datum) }}</td>
                                                    <td class="text-center">
                                                        <v-tooltip
                                                            v-if="booking.opm_eign && booking.opm_eign !== ''"
                                                            :max-width="400"
                                                            bottom
                                                            open-on-hover
                                                            open-on-click
                                                            content-class="custom-tooltip-bg"
                                                        >
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-icon
                                                                    :color="booking.opm_eign && booking.opm_eign !== '' ? 'info' : '#bdbdbd'"
                                                                    v-bind="attrs"
                                                                    v-on="on"
                                                                    style="cursor: pointer;"
                                                                >
                                                                    mdi-information-outline
                                                                </v-icon>
                                                            </template>
                                                            <span>{{ booking.opm_eign }}</span>
                                                        </v-tooltip>
                                                        <v-icon
                                                            v-else
                                                            :color="'#bdbdbd'"
                                                            style="cursor: default;"
                                                        >
                                                            mdi-information-off-outline
                                                        </v-icon>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </v-card>
                            </v-card-text>
                            <v-card-text>
                                <v-row justify="center">
                                    <v-col cols="12" md="10">
                                        <div class="text-caption mb-3 remark-info" style="display: flex; align-items: center; flex-direction: row; gap: 10px; background-color: rgba(33, 150, 243, 0.15); padding: 8px 12px; border-radius: 4px;">
                                            <v-icon left color="info" size="24">mdi-alert-circle-outline</v-icon>
                                            <div style="color: #1976d2; font-weight: 500; font-size: 13px;">This is an internal remark and will not be shared with the homeowner.</div>
                                        </div>
                                        <v-textarea
                                            v-model="remark"
                                            :label="remarkLabel"
                                            rows="5"
                                            outlined
                                            counter
                                            :rules="remarkRules"
                                            placeholder="Please provide a detailed explanation for your decision..."
                                            required
                                        >
                                        </v-textarea>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                    :color="buttonColor"
                                    :disabled="!isRemarkValid"
                                    large
                                    @click="updHehoBknDny()"
                                >
                                    <v-icon left>{{ buttonIcon }}</v-icon>
                                    {{ actionType }} booking
                                </v-btn>
                                <v-spacer></v-spacer>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row v-else>
                    <v-row v-if="process_error===true">
                        <v-col cols="12" class="d-flex flex-column align-center justify-center" style="min-height: 300px;">
                            <v-icon color="error" large style="font-size: 64px;">mdi-alert-circle</v-icon>
                            <div class="text-h5 font-weight-bold mt-4" style="color: #424242;">
                                Something went wrong. Booking could not be processed. Reload page to retry
                            </div>
                        </v-col>
                    </v-row>
                    <v-row v-else>
                        <v-col cols="12" class="d-flex flex-column align-center justify-center" style="min-height: 300px;">
                            <v-icon color="success" large style="font-size: 64px;">mdi-check-circle</v-icon>
                            <div class="text-h5 font-weight-bold mt-4" style="color: #424242;">
                                Process completed successfully. You may close this window.
                            </div>
                        </v-col>
                    </v-row>
                </v-row>
            </v-row>
        </div>
        <div v-else class="d-flex flex-column align-center justify-center" style="min-height: 300px;">
            <v-progress-circular
                indeterminate
                color="primary"
                size="64"
            ></v-progress-circular>
            <div class="text-h6 font-weight-bold mt-4">
                Loading, please wait...
            </div>
        </div>
    </v-container>
</template>

<script>
export default {
    props: {
        param: String,
    },    
    data() { 
        return {
            answer: '',
            loading: true,
            process_ok: false,
            process_error: false,
            temp_token: '',
            remark: '',
            error_message: '',
            error: false,
            currentHeho: {},
            hehoList: []
        }
    },
    mounted() {

        this.answer = (this.param && this.param.split(':')[1] === 'T') ? 'true' : 'false',
        // get some data using the encryption key
        this.$axios
            .post("ares/json/ares/heho/getHehoAgentApprovalData.p", {
                header: {
                    request: "getHehoAgentApprovalData"
                },
                getHehoAgentApprovalData: {
                    param: this.param.split(':')[0]
                }
            })
            .then(res => {
                if (res.data.error) {
                    this.loading = false;
                    this.error = true;
                    this.error_message = res.data.error.message;
                } else {
                    this.currentHeho = res.data.getHehoAgentApprovalData.currentHeho;
                    this.hehoList = res.data.getHehoAgentApprovalData.hehoList;
                    this.temp_token = res.data.getHehoAgentApprovalData.temp_token;
                    this.loading = false;
                }
            });      
    },
    methods: {
        formatDate(dateString) {
            const date = new Date(dateString);
            return date.toLocaleDateString('en-GB', {
                day: '2-digit',
                month: '2-digit', 
                year: 'numeric'
            });
        },        
        updHehoBknDny() {
            this.$axios.post("ares/json/ares/heho/updHehoBknDnyByAgent.p", {
                header: {
                    token: this.temp_token,
                    request: "updHehoBknDny",
                },
                updHehoBknDny: {
                    heho_encrid: this.currentHeho.heho_encrid,
                    heho_bkn_dny: this.answer === 'true'? 'bkn' : 'dny',
                    heho_result: this.remark,
                },
            }).then((res) => {
                if (res.data.error) {
                    this.process_error = true;
                    this.process_ok = true;
                } else {
                    this.process_ok = true;
                    this.process_error = false;
                }
            });
        }
    },
    computed: {        
        pageTitle() {
            return this.answer === 'true' ? 'Approve Homeowner Booking' : 'Reject Homeowner Booking';
        },        
        remarkLabel() {
            return this.answer === 'true' 
                ? 'Approval Justification (Required) - please provide at least 5 characters' 
                : 'Rejection Reason (Required) - please provide at least 5 characters';
        },
        titleIconColor(){
            return this.answer === 'true' ? 'green' : 'red';
        },
        actionType() {
            return this.answer === 'true' ? 'Approve' : 'Reject';
        },
        buttonColor() {
            return this.answer === 'true' ? 'success' : 'error';
        },
        buttonIcon() {
            return this.answer === 'true' ? 'mdi-check-circle' : 'mdi-cancel';
        },
        isRemarkValid() {
            return this.remark && this.remark.trim().length >= 5;
        },        
        remarkRules() {
            return [
                v => !!v || 'Remark is required',
                v => (v && v.length >= 5) || 'Remark must be at least 5 characters long'
            ];
        }
    }
}
</script>

<style scoped>
.flex {
    display: flex;
    flex-direction: row;
    align-items: center;
}
.custom-tooltip-bg {
    background-color: rgba(33, 150, 243, 0.9); /* info blue with 50% transparency */
    color: #fff;
    border: 1px solid #2196f3;
    padding: 10px;
    border-radius: 4px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    max-width: 300px;
}
</style>